const RELATIONSHIP_ERROR_CODE = {
  RELATIONSHIP_001: 'RELATIONSHIP001',
  RELATIONSHIP_002: 'RELATIONSHIP002',
  RELATIONSHIP_003: 'RELATIONSHIP003',
  RELATIONSHIP_004: 'RELATIONSHIP004',
  RELATIONSHIP_005: 'RELATIONSHIP005',
  RELATIONSHIP_006: 'RELATIONSHIP006',
  RELATIONSHIP_007: 'RELATIONSHIP007',
  RELATIONSHIP_008: 'RELATIONSHIP008',
  RELATIONSHIP_009: 'RELATIONSHIP009',
};

const RELATIONSHIP_ERROR_MESSAGE = {
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_001]: 'categoryId 는 int 형식의 필수값입니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_002]: 'productIds 는 길이 1 이상의 array 입니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_003]: '상품 삭제는 최대 200개 까지만 가능 합니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_004]: 'productIds 의 요소는 int 형식입니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_005]: 'productIds 의 요소는 unique 해야합니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_006]: '존재하지 않는 상품/카테고리 입니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_007]: '삭제할 수 없는 상품의 카테고리가 존재합니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_008]: '중복 된 내용이 있습니다.',
  [RELATIONSHIP_ERROR_CODE.RELATIONSHIP_009]: '카테고리 ID가 중복 입력 되었습니다.',
};

export default RELATIONSHIP_ERROR_MESSAGE;
